import store from '../../store/store';

export const requireAuth = (nextState, replace) => {
  if (store.getState().getIn(['session', 'state']) !== 'LOGGED_IN') {
    replace({
      pathname: '/auth',
      state: { nextPathname: nextState.location.pathname },
    });
  }
};

export const requireAuthOnChange = (prevState, nextState, replace) => {
  // load(store);
  requireAuth(nextState, replace);
};
